import { cn } from '@/lib/utils';
import { formatNumber } from '@/lib/formatNumber';

interface FormattedNumberProps {
  value: number | null | undefined;
  className?: string;
  /** When true, render em dash for zero (quantity tables). */
  hideZero?: boolean;
  /** Prefix/suffix for signed values (e.g. stock movements). */
  prefix?: string;
  suffix?: string;
}

export function FormattedNumber({
  value,
  className,
  hideZero = false,
  prefix = '',
  suffix = '',
}: FormattedNumberProps) {
  if (value == null || !Number.isFinite(value)) {
    return <span className={cn('text-muted-foreground', className)}>—</span>;
  }
  if (hideZero && value <= 0) {
    return <span className={cn('text-muted-foreground', className)}>—</span>;
  }
  return (
    <span className={cn('tabular-nums', className)}>
      {prefix}
      {formatNumber(value)}
      {suffix}
    </span>
  );
}
